// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"31e44c34","118":"10b4d676","138":"d6ab80ae","311":"0782d91e","418":"a66bc8b6","489":"21559d03","787":"a33d2cd0","896":"edcd947f","979":"f16bcc0c"}[chunkId] + ".chunk.js";
};